import React from 'react';
import PropTypes from 'prop-types';
import styles from "./Leg.module.scss";
import CityPairLabel from "../CityPairLabel/CityPairLabel";
import NumberOfNights from "../NumberOfNights/NumberOfNights";
import AirportRadioInput from "./AirportRadioInput/AirportRadioInput";
import {withTranslation} from "react-i18next";

const Leg = ({
     selectedAirport, icon, originLabel, destinationLabel, onSelect, onNightSelect, selectedNight,
     departureDateLabel, disabledAirports, disabledNights, message, disabled, hide, t, ...props
 }) => {

    if (hide) {
        return null;
    }

    const containerClasses = [styles.legContainer];
    if (disabled) containerClasses.push(styles.disabled);

    const pdlSelected = selectedAirport === 'PDL';
    const terSelected = selectedAirport === 'TER';
    const pdlDisabled = disabled || disabledAirports.includes('PDL');
    const terDisabled = disabled || disabledAirports.includes('TER');
    const selectedAirportLabel = terSelected ? t('Departure from Terceira') : t('Departure from Ponta Delgada');

    return (
        <>
            <div className={containerClasses.join(' ')}>
                <div className={styles.cityPairContainer}>
                    <div className={styles.cityPairLabel}>
                        {icon}&nbsp;&nbsp;
                        <CityPairLabel
                            origin={originLabel}
                            destination={destinationLabel}/>
                    </div>
                    <div className={styles.cityPairForm}>
                        <AirportRadioInput
                            disabled={pdlDisabled}
                            checked={pdlSelected}
                            onSelect={() => onSelect('PDL')}>
                            {t('Ponta Delgada')}
                        </AirportRadioInput>
                        <AirportRadioInput
                            disabled={terDisabled}
                            checked={terSelected}
                            onSelect={() => onSelect('TER')}>
                            {t('Terceira island')}
                        </AirportRadioInput>
                    </div>
                </div>
                <div className={styles.departureDateLabelContainer}>
                    {selectedAirport ? <span className={styles.departureDateLabel}>{selectedAirportLabel}</span> : ''}
                    {departureDateLabel && <span className={styles.departureDate}>{departureDateLabel.split(' ')[0] + ' ' + t(departureDateLabel.split(' ')[1]).substring(0, 3)}&nbsp;</span>}
                </div>
                <div className={styles.numberOfNightsContainer}>
                    <NumberOfNights
                        title={t('Choose how many nights')}
                        disabledNights={disabledNights}
                        nightSelectHandler={onNightSelect}
                        currentNight={selectedNight}
                        disableAll={!selectedAirport}/>
                </div>
            </div>
            {message && (
                <div className={styles.message}>
                    {t(message)}
                </div>
            )}
        </>

    );
};

Leg.propTypes = {
    icon: PropTypes.any,
    originLabel: PropTypes.string,
    destinationLabel: PropTypes.string,
    departureDateLabel: PropTypes.string,
    selectedAirport: PropTypes.oneOf(['PDL', 'TER']),
    selectedNight: PropTypes.number,
    disabledAirports: PropTypes.array,
    disabledNights: PropTypes.array,
    onSelect: PropTypes.func,
    onNightSelect: PropTypes.func,
    message: PropTypes.string,
    hide: PropTypes.bool,
    disabled: PropTypes.bool,
    t: PropTypes.func,
};

Leg.defaultProps = {
    icon: <i className={`icon-sata-icon-aviao-partida`} style={{fontSize: '1.2em', color: '#2e6da4'}}/>,
    originLabel: '',
    destinationLabel: '',
    departureDateLabel: '',
    selectedAirport: '',
    selectedNight: null,
    disabledAirports: [],
    disabledNights: [],
    onSelect: () => null,
    onNightSelect: () => null,
    message: null,
    hide: false,
    disabled: false,
    t: s => s
};

export default withTranslation()(Leg);
